/**
 * Returns a version of the function that includes a cache for all
 * requests to the function.
 * NOTE: Arguments must be serializable, ie. no cyclic dependencies allowed.
 * @param func Function to cache
 */
export const withCaching = <TArgs extends Array<any>, TReturnValue>(
  func: (...args: TArgs) => TReturnValue,
) => {
  const cache: {[key: string]: ReturnType<typeof func>} = {};
  return (...args: Parameters<typeof func>): ReturnType<typeof func> => {
    const key = JSON.stringify(args);
    if (cache[key] === undefined) {
      // Call original function
      cache[key] = func(...args);
    }
    return cache[key];
  };
};
